import { useToast } from '@/components/ui/use-toast.js'
import { ITERATION_COMMANDS } from '@/const/const.ts'
import { ANALYTIC_EVENTS, analyticsTrackEvent } from '@/services/Analytics.js'
import { useCallback } from 'react'
import { UserInputCommand, useSendUserCommand } from '../sendUserCommand.ts'

export function useRestartIteration(iterationId: string | null) {
  const { toast } = useToast()
  const sendCommand = useSendUserCommand(iterationId)

  const restart = useCallback(async () => {
    sendCommand.mutate(
      {
        command: ITERATION_COMMANDS.RESTART,
      },
      {
        onError(error) {
          console.error('Error restarting iteration', error)
          toast({
            variant: 'destructive',
            title: 'We could’t restart your project.',
            description: 'Try refreshing the page or contact Proofs team.',
          })
        },
        onSuccess() {
          analyticsTrackEvent(ANALYTIC_EVENTS.ITERATION_RESTART, {
            iterationId: iterationId,
          })
        },
      }
    )
  }, [sendCommand, toast, iterationId])

  return { ...sendCommand, mutate: restart, mutateAsync: restart }
}
